import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'valor-item',
  templateUrl: './valor-item.component.html',
  styleUrls: ['./valor-item.component.scss']
})
export class ValorItemComponent implements OnInit {

  @Input("data") data:any = null;

  constructor() { }

  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
